import "intersection-observer";

const callbacks = new WeakMap();

let observer;

const observerCallback = (entries) => {
	entries.forEach((entry) => {
		if (callbacks.has(entry.target)) {
			const callback = callbacks.get(entry.target);

			callback(entry);
		}
	});
};

export default {
	inserted(el, { value, arg }) {
		if (observer === undefined) {
			observer = new IntersectionObserver(observerCallback, {
				threshold: [0, 1]
			});
		}

		if (arg || arg === undefined) {
			observer.observe(el);
		}

		callbacks.set(el, value);
	},

	update(el, { arg }) {
		if (arg || arg === undefined) {
			observer.observe(el);
		} else {
			observer.unobserve(el);
		}
	},

	unbind(el) {
		observer.unobserve(el);
		callbacks.delete(el);
	}
};
